import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarCheck2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg, useAdminApi } from "@/lib/api";

export default function CalendarTab() {
  const call = useAdminApi();
  const [st, setSt] = useState(null);
  const refresh = useCallback(() => call("get", "/admin/gcal").then(setSt), [call]);

  useEffect(() => {
    refresh();
    const p = new URLSearchParams(window.location.search).get("gcal");
    if (p === "connected") toast.success("Google Calendar connected");
    if (p === "error") toast.error("Google Calendar connection failed");
  }, [refresh]);

  const connect = async () => {
    try {
      const { url } = await call("post", "/admin/gcal/connect");
      window.location.href = url;
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const disconnect = async () => {
    await call("post", "/admin/gcal/disconnect");
    refresh();
  };

  if (!st) return <div className="h-24 animate-pulse rounded-xl bg-white/5" />;
  return (
    <div className="space-y-4" data-testid="admin-calendar">
      <p className="flex items-center gap-2 font-display text-lg text-white"><CalendarCheck2 className="h-5 w-5 text-emerald-300" /> Google Calendar</p>
      <p className="text-sm text-emerald-100/75">
        When connected, busy times in your Google Calendar are hidden from patients, and every paid booking is added to your calendar automatically.
      </p>
      {!st.configured && (
        <p className="rounded-xl bg-amber-200/10 p-3 text-sm text-amber-100" data-testid="gcal-not-configured">
          Google Calendar keys are not added yet. Slots still work from the hours you set here.
        </p>
      )}
      {st.configured && (
        <p className="text-sm" data-testid="gcal-status">
          Status: {st.connected ? <span className="text-emerald-300">Connected{st.email ? ` (${st.email})` : ""}</span> : <span className="text-amber-200">Not connected</span>}
        </p>
      )}
      <div className="flex gap-2">
        {st.configured && !st.connected && <Button data-testid="gcal-connect-btn" onClick={connect} className="rounded-full bg-emerald-400 text-emerald-950">Connect Google Calendar</Button>}
        {st.connected && <Button variant="ghost" data-testid="gcal-disconnect-btn" onClick={disconnect}>Disconnect</Button>}
      </div>
      <p className="break-all text-xs text-emerald-100/50">Authorised redirect URI for Google Cloud: {st.redirect_uri}</p>
    </div>
  );
}
